import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  type: "",
  uuid: "",
  isTagging: false,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tagData: {} as any,
  sport: "baseball",
  sportInitializedFromSocket: false,
  isInStatTrackingMode: false,
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionType: (state, action) => {
      state.type = action.payload;
    },
    setSessionUuid: (state, action) => {
      state.uuid = action.payload;
    },
    setSport: (state, action) => {
      state.sport = action.payload;
    },
    setSportInitializedFromSocket: (state, action) => {
      state.sportInitializedFromSocket = action.payload;
    },
    putTag: (state, action) => {
      const { key, value } = action.payload;

      // Logic to auto tag based on playResult selection
      if (key === "playResult") {
        if (["Out", "Sacrifice"].includes(value)) {
          state.tagData.pitchResult = "InPlay";
          state.tagData.playResult = value;
          state.tagData.outsRecorded = 1;
          state.tagData.runsScored = 0;
        } else if (value === "HomeRun") {
          state.tagData.pitchResult = "InPlay";
          state.tagData.playResult = value;
          state.tagData.runsScored = 1;
          state.tagData.outsRecorded = 0;
        } else if (["StrikeoutLooking", "StrikeoutSwinging"].includes(value)) {
          state.tagData.playResult = value;
          state.tagData.outsRecorded = 1;
          state.tagData.runsScored = 0;
        } else if (value === "FieldersChoice") {
          state.tagData.pitchResult = "InPlay";
          state.tagData.playResult = value;
          state.tagData.outsRecorded = 1;
          state.tagData.runsScored = 0;
        } else if (value === "Walk") {
          state.tagData.playResult = value;
          state.tagData.outsRecorded = 0;
          state.tagData.runsScored = 0;
        } else {
          state.tagData.playResult = action.payload.value;
          state.tagData.pitchResult = "InPlay";
          state.tagData.outsRecorded = 0;
          state.tagData.runsScored = 0;
        }
      }

      state.tagData[action.payload.key] = action.payload.value;
    },
    removeTag: (state, action) => {
      delete state.tagData[action.payload.key];
    },
    setTaggingState: (state, action) => {
      state.isTagging = action.payload;
    },
    resetAllTags: (state, action) => {
      if (action.payload) {
        const { key } = action.payload;
        state.tagData = { [key]: state.tagData[key] };
      } else {
        state.tagData = {};
      }
    },
    setTags: (state, action) => {
      state.tagData = action.payload;
    },
    setStatTrackingMode: (state, action) => {
      state.isInStatTrackingMode = action.payload;
    },
  },
});

export const {
  setSessionType,
  setSessionUuid,
  setSport,
  setSportInitializedFromSocket,
  putTag,
  removeTag,
  resetAllTags,
  setTaggingState,
  setTags,
  setStatTrackingMode,
} = sessionSlice.actions;
export default sessionSlice.reducer;
